import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly _loading$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  setLoading(value: boolean) {
    this._loading$.next(value);
  }

  get loading$() {
    return this._loading$;
  }
}
